import React, {ForwardRefRenderFunction, forwardRef} from 'react'

export interface IInputCheckBoxProps {
  error?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  checked?: boolean
  disabled?: boolean
  className?: string
}

const InputCheckBox: ForwardRefRenderFunction<HTMLInputElement, IInputCheckBoxProps> = (
  {error = '', onChange, checked, className, disabled = false, ...props},
  ref
) => (
  <>
    <input
      type="checkbox"
      ref={ref}
      className={className}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      {...props}
    />
    {error ? <span className="error">{error}</span> : null}
  </>
)

export default forwardRef(InputCheckBox)
